import { NgModule } from '@angular/core';

import { ApWindowService } from '@ap/cdk';
import { ApCookieService } from '@ap/persistence';

import { ApAnalyticsDirective } from './analytics.directive';
import { ApAnalyticsService } from './analytics.service';
import { ApPageviewDataService } from './pageview-data/pageview-data.service';

@NgModule({
    imports: [ApAnalyticsDirective],
    exports: [ApAnalyticsDirective],
    providers: [ApAnalyticsService, ApPageviewDataService, ApCookieService, ApWindowService]
})
export class ApAnalyticsModule {}
